import { useState } from 'react';
import { useAuth } from './useAuth';
import { hacerSolicitud } from '../helpers/apiClient';
import useEmpresaStore from '../context/empresaStore';

const useGuardarCita = () => {
  const { renovarToken, cerrarSesion } = useAuth();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { empresa_id } = useEmpresaStore();

  // ✅ Función para guardar cita
  const guardarCita = async (almacenId, cab_id, fecha, horaInicio, horaFin, comentariosAdAlmcn,comentariosAdCrr, url) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await hacerSolicitud(
        url,
        {
          method: 'POST',
          body: JSON.stringify({
            almacenId,
            cab_id,
            fecha,
            dataIni: horaInicio,
            dataFin: horaFin,
            cometariosAdAlmcn: comentariosAdAlmcn,
            cometariosAdCrr: comentariosAdCrr,
            empresa_id: empresa_id,
          }),
        },
        renovarToken,
        cerrarSesion
      );

      setSuccess(true);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { guardarCita, error, success, loading };
};

export default useGuardarCita;
